<template>
  <div style="position: relative">
    <v-text-field
      v-show="dataLoaded"
      placeholder="Cautare"
      hint="Se cauta dupa id_scara, adresa, observatii adresa si observatii"
      clearable
      persistent-hint
      append-icon="mdi-magnify"
      solo
      :loading="loading"
      single-line
      @click:append="_cbSearch"
      @keydown.enter="_cbSearch"
      :suffix="total"
      v-model="searchTerm">
    </v-text-field>
    <v-list three-line dense v-show="dataLoaded">
      <v-subheader>
        Simboluri

        <!-- <v-scale-transition appear group> -->
          <template v-if="user && user.admin">
            <v-btn icon @click.stop="uplaodXLSX" color="primary" flat key="xlsx" title="Upload simboluri din xlsx" :ripple="false">
              <v-icon>mdi-file-upload</v-icon>
            </v-btn>
          </template>

          <v-avatar size="18" class="mx-1" @click="toggleDone" key="toggle-done" :title="done === null ? 'Done si Not Done' : (done === 1 ? 'Done' : 'Not Done')">
            <v-icon :color="doneColor" :size="20">
              {{done === null ? 'mdi-check-circle-outline' : (done === 1 ? 'mdi-check-circle' : 'mdi-close-circle')}}
            </v-icon>
          </v-avatar>

          <v-avatar size="18" class="mx-1" @click="toggleEdited" key="toggle-edited" :title="edited === null ? 'Editate si Needitate' : (edited === 1 ? 'Editate' : 'Needitate')">
            <v-icon :color="editedColor" :size="20">
              {{edited === null ? 'mdi-pencil-outline' : (edited === 1 ? 'mdi-pencil' : 'mdi-pencil-off')}}
            </v-icon>
          </v-avatar>

          <v-avatar size="18" class="mx-1" @click="togglePhotos" key="toggle-photos" :title="photos === null ? 'Cu si Fara Poze' : (photos === 1 ? 'Cu Poze' : 'Fara Poze')">
            <v-icon :color="photosColor" :size="20">
              {{photos === null ? 'mdi-camera-outline' : (photos === 1 ? 'mdi-camera' : 'mdi-camera-off')}}
            </v-icon>
          </v-avatar>

          <!-- <v-avatar size="18" class="mx-1" @click="togglePdfs" key="toggle-pdfs" :title="pdfs === null ? 'Cu si Fara Pdf-uri' : (pdfs === 1 ? 'Cu Pdf-uri' : 'Fara Pdf-uri')">
            <v-icon :color="pdfsColor" :size="20">
              {{pdfs === null ? 'mdi-file-pdf-outline' : (pdfs === 1 ? 'mdi-file-pdf' : 'mdi-file-pdf')}}
            </v-icon>
          </v-avatar> -->

          <template v-if="user && !user.dummy">
            <v-btn icon @click.stop="_cbAddEntity" color="primary" flat key="add" title="Adauga manual un simbol" :ripple="false">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </template>
        <!-- </v-scale-transition> -->

      </v-subheader>

      <v-subheader>
        Eticheta
        <v-chip @click="openLabelsDialog" close @input="resetLabel" small outline text-color="primary">
          <v-icon :size="12">mdi-filter</v-icon>
          <span class="text-truncate" style="max-width: 15vw">
            {{ selectedLabel === null ? 'Toate' : (selectedLabel === undefined ? 'Nespecificat' : selectedLabel) }}
          </span>
        </v-chip>
        &nbsp;
        Zona
        <v-chip @click="openZonesDialog" close @input="resetZona" small outline text-color="primary">
          <v-icon :size="12">mdi-filter</v-icon>
          <span class="text-truncate" style="max-width: 15vw">
          {{ selectedZona === null ? 'Toate' : (selectedZona === undefined ? 'Nespecificat' : selectedZona) }}
          </span>
        </v-chip>
      </v-subheader>

      <v-subheader v-if="user && user.admin">
        Interval
        <v-chip small outline text-color="primary">{{dataInceput | dateFormat}}</v-chip>
        -
        <v-chip small outline text-color="primary">{{dataSfarsit | dateFormat}}</v-chip>
      </v-subheader>
      <!-- <v-list-tile v-for="item in items" :key="item._id" v-touch="{ end: (wrapper) => _cbSwipe(wrapper) }"> -->
      <template v-for="item in items">
        <v-list-tile :key="item._id" class="mb-2" v-touch="{
          left: () => _cbNavigate('details', item),
          right: () => _cbNavigate('map', item),
        }">
          <v-list-tile-action @click="_cbNavigate('map', item)">
            <!-- <v-scale-transition appear> -->
              <v-avatar title="Mergi la harta" tile>
                <v-img :src="getItemType(item)" :transition="false"></v-img>
              </v-avatar>
            <!-- </v-scale-transition> -->
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{item.id_scara}}
              <!-- <v-scale-transition appear group> -->
              <span>
                <v-icon small v-if="item.done" color="primary" :key="item._id + 'done'" title="Done">mdi-check</v-icon>
                <v-icon small v-else color="error" :key="item._id + 'notdone'" title="Not done">mdi-close</v-icon>
                <v-icon small color="primary" v-if="item.photos.length" :key="item._id + 'photo-on'" title="Poze incarcate">mdi-image</v-icon>
                <v-icon small color="error" v-else :key="item._id + 'photo-off'" title="Nu exista poze incarcate">mdi-image-off</v-icon>
                <span :key="item._id + 'len'">{{item.photos.length}}</span>
              </span>
              <!-- </v-scale-transition> -->
              <!-- <v-scale-transition appear group> -->
              <!-- <span>
                <v-icon small color="primary" v-if="item.pdfs.length" :key="item._id + 'pdf-on'" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                <v-icon small color="error" v-else :key="item._id + 'pdf-off'" title="Nu exista pdf-uri incarcate">mdi-file-pdf</v-icon>
                <span :key="item._id + 'len'">{{item.pdfs.length}}</span>
              </span> -->
              <!-- </v-scale-transition> -->
              <!-- <v-scale-transition appear group> -->
              <span>
                <v-icon class="ml-1" small :color="filesInQueue(item._id) ? 'primary' : 'blue-grey'" :key="item._id + 'up'" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                <span class="ml-1" :key="item._id + 'lenq'">{{filesInQueue(item._id)}}</span>
              </span>
              <!-- </v-scale-transition> -->
            </v-list-tile-title>
            <v-list-tile-sub-title>{{item.adresa}}</v-list-tile-sub-title>
            <v-list-tile-sub-title>{{item.observatii_adresa}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action @click="_cbNavigate('details', item)">
            <!-- <v-scale-transition appear> -->
              <v-icon large title="Mergi la detalii">mdi-format-list-bulleted-type</v-icon>
            <!-- </v-scale-transition> -->
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="item._id + '_divider'"></v-divider>
      </template>

      <v-list-tile>
        <v-list-tile-content>
          <div class="d-flex" style="width: 100%">
            <v-spacer></v-spacer>
            <v-pagination
              style="justify-content: center"
              v-model="page"
              :length="totalPages"
              circle
            ></v-pagination>
            <v-spacer></v-spacer>
          </div>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-dialog v-model="dialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Incarcare XLSX cu simboluri</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="label"
            label="Eticheta"
            hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate">
          </v-text-field>
          <form ref="form">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading" :ripple="false">Renunta</v-btn>
          <v-btn flat color="primary" @click="filesAdded" :loading="uploading" :disabled="uploading" :ripple="false">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="labelsDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa eticheta</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedLabel">
            <v-radio
              v-for="label in labels"
              :key="label.label + label.data"
              :label="`${label.label} (${label.data})` || 'Toate'"
              :value="label.label || null"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="closeLabelsDialog" :ripple="false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="zonesDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa zona</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedZona">
            <v-radio
              v-for="zona in zones"
              :key="zona.zona"
              :label="zona.zona || 'Toate'"
              :value="zona.zona || null"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="closeZonesDialog" :ripple="false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" persistent scrollable :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Adaugare simbol</v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="addFormValid" lazy-validation>
            <template v-for="field in fields">
              <template v-if="getType(field.value)">
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'eticheta'"
                  :items="labelsText"
                  label="Eticheta"
                  :key="field.value"
                  :menu-props="{transition: false}"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>

                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'zona'"
                  :items="zonesText"
                  label="Zona"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :menu-props="{transition: false}"
                  :rules="getRules(field.value)">
                </v-select>

                <v-text-field
                  class="my-3"
                  v-if="getType(field.value) === 'text'"
                  :key="field.value"
                  :type="getType(field.value)"
                  v-model="newEntity[field.value]"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  :readonly="field.value === 'id_scara'"
                  validate-on-blur
                  solo
                  flat>
                </v-text-field>
                <v-textarea
                  class="my-3"
                  v-if="['textarea'].includes(getType(field.value))"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  auto-grow
                  :rows="1"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  validate-on-blur
                  solo
                  flat>
                </v-textarea>

                <div style="width: 100%; height: 50vh" v-if="getType(field.value) === 'map'" :key="field.value">
                  <GmapMap
                    :center="mapCenter"
                    :zoom="zoom"
                    :map-type-id="mapType"
                    :style="{ width: '100%', height: '100%' }"
                    ref="map">

                    <GmapMarker
                      :position="mapCenter"
                      :draggable="true"
                      @dragend="_cbDragEnd" />

                  </GmapMap>
                </div>
              </template>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddDialog(0)" :ripple="false">Renunta</v-btn>
          <v-btn flat color="primary" @click="closeAddDialog(1)" :ripple="false">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="text-align: center">
      <div class="pt-5 data-loading" style="text-align: center" v-if="!dataLoaded">
        <img src="/logo.svg" alt="loader-logo" style="width:25vw">
      </div>
      <v-btn fab flat large @click="_cbRefresh" :ripple="false" v-if="!dataLoaded">
        <v-icon color="primary">mdi-refresh</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import uniqid from 'uniqid'

export default {
  name: 'entities',
  data: () => ({
    dataLoaded: false,
    search: '',
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    zonesDialog: false,
    addDialog: false,
    addFormValid: true,
    newEntity: {
      eticheta: null,
      zona: null,
      id_scara: null,
      adresa: null,
      observatii_adresa: null,
      centru_geometric: {
        lat: 44.4356538,
        lng: 26.0339367
      }
    },
    fields: [ // eticheta, id_scara, adresa, observatii_adresa, centru_geometric
      {
        value: 'eticheta',
        label: 'ETICHETA'
      },
      {
        value: 'zona',
        label: 'ZONA'
      },
      {
        value: 'id_scara',
        label: 'ID SCARA'
      },
      {
        value: 'adresa',
        label: 'ADRESA'
      },
      {
        value: 'observatii_adresa',
        label: 'OBSERVATII ADRESA'
      },
      {
        value: 'centru_geometric',
        label: 'CENTRU GEOMETRIC'
      }
    ]
  }),
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : 'nimic selectat'
    }
  },
  computed: {
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/items']
    },
    total () {
      return String(this.$store.getters['entities/total'])
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    totalPages () {
      return this.$store.getters['entities/totalPages']
    },
    filters () {
      return this.$store.getters['entities/filters']
    },
    done () {
      return this.$store.getters['entities/done']
    },
    edited () {
      return this.$store.getters['entities/edited']
    },
    photos () {
      return this.$store.getters['entities/photos']
    },
    pdfs () {
      return this.$store.getters['entities/pdfs']
    },
    doneColor () {
      if (this.done === 1) return 'primary'
      if (this.done === -1) return 'error'
      return 'blue-grey'
    },
    editedColor () {
      if (this.edited === 1) return 'primary'
      if (this.edited === -1) return 'error'
      return 'blue-grey'
    },
    photosColor () {
      if (this.photos === 1) return 'primary'
      if (this.photos === -1) return 'error'
      return 'blue-grey'
    },
    pdfsColor () {
      if (this.pdfs === 1) return 'primary'
      if (this.pdfs === -1) return 'error'
      return 'blue-grey'
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    selectedLabel: {
      get () {
        return this.$store.getters['entities/selectedLabel']
      },
      set (value) {
        this.$store.commit('entities/setSelectedLabel', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    selectedZona: {
      get () {
        return this.$store.getters['entities/selectedZona']
      },
      set (value) {
        this.$store.commit('entities/setSelectedZona', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    labelsText () {
      return this.$store.getters['entities/labels'].map(label => label.label)
    },
    zonesText () {
      return this.$store.getters['entities/zones'].map(zona => zona.zona)
    },

    dataInceput () {
      return this.$store.getters['entities/dataInceput']
    },
    dataSfarsit () {
      return this.$store.getters['entities/dataSfarsit']
    }
  },
  watch: {
    items: {
      immediate: true,
      handler (obj) {
        this.dataLoaded = true
      }
    }
    // 'newEntity.nr_niveluri_vizibile' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.etaj_tehnic_vizibil' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.comert_servicii' (v) {
    //   if (v === 'Nu') this.$set(this.newEntity, 'nr_niveluri_comert_servicii', null)
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.nr_niveluri_comert_servicii' (v) {
    //   this.computeRegimInaltime()
    // }
  },
  methods: {
    resetLabel () {
      this.selectedLabel = null
    },
    resetZona () {
      this.selectedZona = null
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    openZonesDialog () {
      this.zonesDialog = true
    },
    closeZonesDialog () {
      this.zonesDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    filesInQueue (entity) {
      return this.files.filter(file => file.entity === entity && !file.uploaded).length
    },
    toggleDone () {
      this.$store.dispatch('entities/toggleDone')
    },
    toggleEdited () {
      this.$store.dispatch('entities/toggleEdited')
    },
    togglePhotos () {
      this.$store.dispatch('entities/togglePhotos')
    },
    togglePdfs () {
      this.$store.dispatch('entities/togglePdfs')
    },
    getItemType (marker) {
      // blue: #2a96d3
      // green: #1a9688
      // orange: #ff5722
      // blue-grey: #607d8b
      // light-blue: #cbffff
      // light-pink: #ffafcc
      if (marker.addedBy) {
        if (marker.done) return '/svg/done_people.svg'
        return marker.user ? '/svg/edited_people.svg' : '/svg/unedited_people.svg'
      } else {
        if (marker.done) return '/svg/done.svg'
        return marker.user ? '/svg/edited.svg' : '/svg/unedited.svg'
      }
    },
    _cbNavigate (where, entity) {
      if (where === 'map') {
        this.$store.commit('setMapCenter', entity.centru_geometric)
        this.$store.commit('setZoom', 17)
      }
      this.$router.push({ name: where, params: { entity: entity._id } })
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded () {
      if (!this.$refs.fileinput.files.length) return

      // this.$store.commit('setLoading', true)
      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(error => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
            alert('Whoops! Whoopsie! Ceva nu a functionat...')
          }).finally(() => {
            this.$store.commit('incrementRefreshCount')
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        // this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },

    _cbAddEntity () {
      this.addDialog = true
      this.newEntity.id_scara = uniqid()
    },
    closeAddDialog (mode) {
      if (mode) {
        if (!this.$refs.addForm.validate()) return
        this.addDialog = false
        this.$refs.addForm.resetValidation()

        const obj2save = {}

        Object.keys(this.newEntity).forEach(key => {
          switch (this.getType(key)) {
            case 'map': obj2save[key] = this.newEntity[key] ? { ...this.newEntity[key] } : null; break
            case 'number': obj2save[key] = !isNaN(this.newEntity[key]) ? Number(this.newEntity[key]) : null; break
            default: obj2save[key] = this.newEntity[key] === null ? null : String(this.newEntity[key])
          }

          this.newEntity[key] = null
          // this.newEntity.id_scara = null
        })

        this.newEntity.centru_geometric = { ...this.mapCenter }
        this.newEntity.regim_inaltime = 'P'

        if (JSON.stringify(this.newEntity) !== JSON.stringify(obj2save)) {
          obj2save.done = false
          obj2save.user = this.user.username
          if (!this.user.admin) {
            obj2save.addedBy = this.user.username
          }

          this.$store.state.services.entities.create(obj2save)
        }
      } else {
        this.addDialog = false
        this.$refs.addForm.resetValidation()
        this.newEntity = {
          eticheta: null,
          zona: null,
          id_scara: null,
          adresa: null,
          observatii_adresa: null,
          centru_geometric: { ...this.mapCenter }
        }
      }
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'id_scara': return 'text'
        case 'adresa': return 'textarea'
        case 'observatii_adresa': return 'textarea'
        case 'centru_geometric': return 'map'
        default: return false
      }
    },
    _cbDragEnd: debounce(function ($event) {
      const pos = { lat: $event.latLng.lat(), lng: $event.latLng.lng() }
      this.$set(this.newEntity, 'centru_geometric', pos)
      this.$forceUpdate()
    }, 1000),
    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'adresa':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        default: return []
      }
    },
    _cbRefresh () {
      this.$store.dispatch('entities/fetchEntities')
    }
  },
  mounted () {
    if (this.searchTerm) {
      this.search = this.searchTerm
    }
  }
}
</script>

<style>

</style>
